import { render, staticRenderFns } from "./FaseFenologicaModal.vue?vue&type=template&id=932b484a&scoped=true"
import script from "./FaseFenologicaModal.vue?vue&type=script&lang=js"
export * from "./FaseFenologicaModal.vue?vue&type=script&lang=js"
import style0 from "./FaseFenologicaModal.vue?vue&type=style&index=0&id=932b484a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932b484a",
  null
  
)

export default component.exports